<template>
  <div>
    <div class="container">
      <div class="container_con">
        <div class="intro">
          <h1>打造Web 3.0模式</h1>
          <h1>的一站式会议记录平台</h1>
          <h2 style="margin-top: 10px">
            记录历史有《史记》，记录国家成长的平台有《新闻联播》，记录个人美好生活的平台有抖音、视频号、快手。
          </h2>
          <h2>那么，有没有一个平台来记录企业的成长？</h2>
          <h2>企业的每一次成长都值得记录和分享 —— 数东方APP</h2>
          <div class="down_cell">
            <el-popover placement="bottom" width="150" trigger="hover">
              <!-- <canvas ref="qrCanvas"></canvas> -->
              <img
                src="@/assets/common/image/app_code.png"
                alt="App"
                style="width: 125px; height: 125px"
              />
              <el-button class="down_cell_item" slot="reference">
                <i class="iconfont icon-anzhuo"></i>
                <span>Android版</span>
              </el-button>
            </el-popover>

            <el-popover placement="bottom" width="150" trigger="hover">
              <img
                src="@/assets/common/image/applet_code.jpg"
                alt="小程序"
                style="width: 125px; height: 125px"
              />
              <el-button class="down_cell_item" slot="reference">
                <i class="iconfont icon-xiaochengxu"></i>
                <span>微信小程序</span>
              </el-button>
            </el-popover>
          </div>
        </div>
        <div style="width: 378px; position: relative">
          <LoadingCell :is_loading="is_loading" :title="title"></LoadingCell>
          <LoginCell @setLoginStarus="setLoginStarus"></LoginCell>
        </div>
      </div>

      <img src="@/assets/login/login_bg.jpg" alt="" class="login_bg" />
    </div>

    <div class="login_bottom">
      <span class="txt">© 大事纪数字科技(武汉)有限公司 版权所有</span>
      <div class="login_bottom_item">
        <img
          src="@/assets/common/icon/TB1jwakrbH1gK0jSZFwXXc7aXXa-20-20.avif"
          alt=""
          class="image"
        />
        <p class="txt">
          鄂公网安备42011602000993号 ICP备2021014377号-1
          增值电信业务经营许可证鄂B2-20231125
          网络文化经营许可证：鄂网文(2023)4068-429号
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import router from "@/router";
import { mapState } from "vuex";
import LoginCell from "./components/LoginCell.vue";

import QRCode from "qrcode";
export default {
  name: "LoginView",
  components: { LoginCell },
  data() {
    return {
      user_type: "ua", //ua用户账号密码登录  ca城市合伙人账号密码登录
      login_type: "a", //a账号密码 p手机验证码 c二维码
      hide_pswd: true,
      countdown: 60,
      focusEle: "",
      is_loading: false,
      title: "正在登录...",
    };
  },
  created() {
    // if (this.$store.state.token && this.$store.state.uid) {
    //   this.is_loading = true;
    //   setTimeout(() => {
    //     router.replace("/manage/activity").catch((err) => {
    //       console.log(err);
    //     });
    //     this.is_loading = false;
    //   }, 800);
    // }
  },
  mounted() {},
  beforeDestroy() {
    this.is_loading = false;
  },
  methods: {
    getCode() {
      const canvas = this.$refs.qrCanvas;
      const width = 125;
      const height = 125;
      QRCode.toCanvas(
        canvas,
        `https://dsjszkj.oss-cn-beijing.aliyuncs.com/uploads/apk/__UNI__E4F1206_1105165156_128_jiagu_sign.apk`,
        {
          width,
          height,
        },
        (error) => {
          if (error) console.error(error);
        }
      );
    },
    setLoginStarus({ type, title }) {
      this.is_loading = type;
      this.title = title;
    },
  },
};
</script>

<style lang="scss" scoped>
.login_bg {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
}
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  .container_con {
    width: 100vw;
    height: 100vh;
    padding: 0 180px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .intro {
      h1 {
        font-size: 38px;
        color: #000008;
        line-height: 38px;
      }
      h2 {
        font-size: 16px;
        color: #2a2e34;
        line-height: 32px;
        font-weight: 500;
        white-space: nowrap;
      }

      .down_cell {
        display: flex;
        align-items: center;
        margin-top: 90px;
        .down_cell_item {
          width: 158px;
          height: 52px;
          background: #2f75fb;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 16px;
          .iconfont {
            color: #ffffff;
            font-size: 14px;
          }
          span {
            color: #ffffff;
            font-size: 14px;
            padding-left: 8px;
          }
        }
      }
    }
  }
}

.login_bottom {
  width: 100vw;
  height: 105px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 3;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .txt {
    font-size: 12px;
    color: #41464f;
    white-space: nowrap;
  }
  .login_bottom_item {
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .image {
    height: 16px;
    margin-right: 8px;
  }
}
</style>
